<template>
  <div class="order-dialog">
    <VDialog v-model="dialog" width="800px" height="100%">
      <VCard v-if="orderData" style="height: 100%">
        <div class="d-flex align-center">
          <v-card-title
            class="d-flex justify-lg-space-between"
            style="border-bottom: 1px solid #dfe2e9; width: 100%"
          >
            <span>
              {{ formTitle }}
            </span>
            <a @click="dialog = false" class="mt-2">
              <VIcon color="lightGrey">mdi-close</VIcon>
            </a>
          </v-card-title>
        </div>
        <div class="d-flex ml-4">
          <span
            class="d-inline-block primary--text font-weight-bold"
            v-if="orderData.state"
            :style="{ color: orderData.statusColour }"
            >{{ $t("state") }}: {{ $t(orderData.state) }}
          </span>
        </div>
        <VCardText class="d-flex flex-column">
          <div class="flex-grow-1" style="height: 100%">
            <template>
              <div class="elevation-0">
                <div class="d-flex flex-column" style="height: 100%">
                  <div class="d-flex flex-column" style="height: 45vh">
                    <div class="order-dialog__item" ref="orderItemRef">
                      <div
                        :key="boxIndex"
                        v-for="(box, boxIndex) in orderData.items"
                        :class="[
                          'order-dialog__item__box',
                          {
                            'order-dialog__item__box-is-changed': box.isChanged,
                          },
                        ]"
                      >
                        <div
                          @click="box.showDetails = true"
                          class="order-dialog__item__box__header font-weight-bold"
                          v-if="!box.isEditing"
                        >
                          <div
                            class="d-flex align-center flex-grow-1 flex-wrap"
                          >
                            <span
                              class="d-inline-block mr-2"
                              style="width: 35px"
                              >{{ boxIndex + 1 + (page - 1) * 200 }}</span
                            >
                            <span
                              class="d-inline-block mr-2 order-dialog__item__box__header__text"
                              style=""
                              >{{ box.productName }}</span
                            >
                            <span
                              class="d-inline-block mr-2 px-2 flex no-wrap-text text-center text-ellipsis"
                              style="text-transform: lowercase; width: 15%"
                              >{{ box.count }}
                              {{ box[`unit_type_name_${$i18n.locale}`] }}</span
                            >
                            <span
                              class="d-inline-block mr-2 flex"
                              :style="{
                                textTransform: 'lowercase',
                                color: box.statusColour,
                              }"
                              >{{ $t(box.statusCode) }}
                            </span>
                            <div>
                              <VBtn
                                class="new_style"
                                @click="box.isEditing = true"
                              >
                                <vue-icon icon="newPencilIcon"></vue-icon>
                              </VBtn>
                              <VBtn
                                @click="deleteItemHandler(box, boxIndex)"
                                class="new_style"
                              >
                                <VueIcon icon="newTrashIcon" />
                              </VBtn>
                            </div>
                          </div>
                        </div>
                        <OrderDialogForm
                          :index="boxIndex"
                          @cancel="
                            () => {
                              box.isEditing = false;
                              if (box.isNew && !box.id) {
                                orderData.items.splice(boxIndex, 1);
                              }
                            }
                          "
                          @apply="
                            (data) =>
                              $set(orderData.items, boxIndex, {
                                ...box,
                                ...data,
                              })
                          "
                          :item.sync="box"
                          v-if="box.isEditing"
                        />
                      </div>
                    </div>
                    <div
                      v-show="orderData.items.length === 0"
                      class="order-dialog__item"
                    >
                      <div
                        v-if="!orderData.items.length"
                        class="order-dialog__item__box"
                      >
                        <div class="order-dialog__item__box__header">
                          {{ $t("noDataAvailable") }}
                        </div>
                      </div>
                    </div>
                    <button
                      class="order-dialog__item__add-btn ml-2"
                      @click="addRequestItem"
                      data-test="divisionOrders-orderDialog-addRequest-btn"
                    >
                      <VueIcon
                        class="order-dialog__item__add-btn__icon"
                        icon="plusIcon"
                      ></VueIcon>
                      {{ $t("addPosition") }}
                    </button>
                  </div>
                  <VuePagination
                    @input="getOrderItems"
                    v-model="page"
                    :length="lastPage"
                  />
                </div>
              </div>
            </template>
          </div>
          <div class="text-right d-flex mt-4">
            <VBtn
              @click="dialog = false"
              color="#9EABBE"
              class="mr-2"
              style="width: 50%; color: #fff"
              data-test="divisionOrders-orderDialog-save-btn"
              >{{ $t("toCancel") }}
            </VBtn>
            <VBtn
              @click="save"
              color="primary"
              :loading="loading"
              class="mr-2"
              style="width: 50%"
              data-test="divisionOrders-orderDialog-save-btn"
              >{{ $t("save") }}
            </VBtn>
          </div>
        </VCardText>
      </VCard>
    </VDialog>
    <WarningDialog
      @apply="deleteOrderItem"
      v-model="deleteDialog"
    ></WarningDialog>
  </div>
</template>

<script>
import "./_orderDialog.scss";
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import OrderDialogForm from "@/components/order-dialog/OrderDialogForm";
import { OrderItemModel } from "@/components/order-dialog/OrderItemModel";
import { makerPagination } from "@/utils/pureFunctions.js";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";

const DEFAULT_ORDER_DATA = {
  id: null,
};

export default {
  name: "OrderDialog",
  components: {
    VuePagination,
    OrderDialogForm,
    WarningDialog,
  },
  data() {
    return {
      loading: false,
      formdata: [],
      page: 1,
      lastPage: 0,
      deletedFiles: [],
      selectedOrderItem: null,
      deleteDialog: false,
      dialog: false,
      orderData: { ...DEFAULT_ORDER_DATA, items: [] },
      documentFile: null,
    };
  },
  methods: {
    addRequestItem() {
      const orderItem = new OrderItemModel();
      orderItem.create();
      this.orderData.items.push({ ...orderItem });
      const { orderItemRef } = this.$refs;
      this.$nextTick(() => {
        if (orderItemRef) {
          let heightCount =
            orderItemRef.scrollHeight - orderItemRef.offsetHeight;
          if (heightCount > 0) {
            orderItemRef.scrollTop = heightCount;
          }
        }
      });
    },
    checkRequestAdded(items) {
      if (items.every((item) => item.isNew)) {
        throw new Error("noRequestAdded");
      }
    },
    checkProductSaved(items) {
      if (items.some((item) => item.isEditing)) {
        throw new Error("productNotSaved");
      }
    },
    appendFormData({ items }) {
      // if (id) {
      //   formData.append("id", id);
      // }
      // this.deletedFiles.forEach((item) => {
      //   formData.append("deletedFiles", item);
      // });
      // let itemIndex = 0;
      items.forEach((item) => {
        if (item.isChanged) {
          if (item.id) {
            this.formdata = [
              ...this.formdata,
              {
                id: item.id,
                count: item.count,
                productId: item.product_id,
              },
            ];
          } else {
            this.formdata = [
              ...this.formdata,
              {
                count: item.count,
                productId: item.product_id,
              },
            ];
          }
          // formData.append(`items[${itemIndex}].count`, item.count);
          // formData.append(`items[${itemIndex}].productId`, item.product_id);
          // formData.append(`items[${itemIndex}].unitTypeId `, item.unitTypeId);
          // ++itemIndex;
        }
      });

      return this.formdata;
    },
    async save() {
      this.loading = true;
      this.showLoading();
      try {
        const { id, items } = this.orderData;
        if (!id) {
          this.checkRequestAdded(items);
          this.checkProductSaved(items);
        }

        let formData = {
          items: this.appendFormData({ items, id }),
        };
        await this.$http.post("office/orders/add", formData);
        this.dialog = false;
        this.$emit("saved");
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
        this.loading = false;
      }
    },
    cancelClickHandler() {
      this.dialog = false;
    },
    deleteOrderItem() {
      try {
        this.showLoading();
        this.$http.delete("office/orders/item-delete", {
          params: { order_item_id: this.selectedOrderItem.id },
        });
        this.orderData.items = this.orderData.items.filter((orderItem) => {
          return orderItem.id !== this.selectedOrderItem.id;
        });
        this.setSuccess({ text: this.$t("successfullyDeleted") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    deleteItemHandler(item, index) {
      if (!item.id) {
        this.orderData.items.splice(index, 1);
      } else {
        this.deleteDialog = true;
        this.selectedOrderItem = item;
      }
    },
    async getOrderItems() {
      this.showLoading();
      const limit = 200;
      try {
        const {
          data: { data, total },
        } = await this.$http.get("orders/items-department", {
          params: {
            objectId: this.orderData.id,
            page: this.page - 1,
            limit,
          },
        });
        this.lastPage = makerPagination({ total, limit }).lastPage;
        this.orderData.items = this.parseItems(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    parseItems(items) {
      return items.map((item) => {
        return {
          ...item,
          isEditing: false,
          showDetails: false,
          // unitTypeId: +item.unitTypeId,
          products: [
            {
              id: +item.productId,
              name: item.productName,
              attrs: item.productAttrs,
              unitTypes: [
                {
                  // id: +item.unitTypeId,
                  [`name_${this.$i18n.locale}`]:
                    item[`unit_type_name_${this.$i18n.locale}`],
                },
              ],
            },
          ],
          product_id: +item.productId,
        };
      });
    },
    open(data, item) {
      if (data) {
        if (data.item.attachments) {
          this.page = data.item.itemsCurrentPage;
          this.lastPage = data.item.itemsPageCount;
        }
        this.orderData = {
          ...data.item,
          items: this.parseItems(data.item.items),
        };
        if (item) {
          this.addRequestItem();
        }
      } else {
        this.addRequestItem();
      }
      this.dialog = true;
      // if (data && data.item.attachments && data.item.attachments.length) {
      //   this.$nextTick(() => {
      //     this.$refs.fileWrap.openFile(data.item.attachments[0]);
      //   });
      // }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.orderData = { ...DEFAULT_ORDER_DATA, items: [] };
        this.dialog = false;
        this.deletedFiles = [];
      }
    },
  },
  computed: {
    isUpdate() {
      return !!this.orderData.id;
    },
    formTitle() {
      if (this.isUpdate)
        return this.$t("requestNumberN", { number: this.orderData.numb });
      else return this.$t("createOrder");
    },
  },
};
</script>

<style scoped lang="scss">
div.v-card {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .v-card__text {
    padding-top: 16px;
  }
}
</style>
